import {
  mapMyRfiItemToGridRow,
  mapGridRowToExportRecord as mapMyRfiRowToExportRecord,
  sortConfigToApiSortParamsWithFieldMap,
} from "./myRfiGridRowMapper";

/**
 * Toggle server-side sort for Provider Requested RFIs vs client-side sort on the current page.
 */
export const PROVIDER_REQUESTED_RFIS_USE_SERVER_SORT = true;

/**
 * Column keys → `order_by` for `RFI-Templates/Provider/get_rfis`.
 * Align with backend when enabling server-side sort (same idea as MY_RFI_API_ORDER_BY_FIELD).
 */
export const VENDOR_REQUESTED_RFI_API_ORDER_BY_FIELD = {
  sponsor: "sponsor_name",
  template: "services",
  gxp: "gxp",
  location: "location",
  risk: "risk_summary",
  status: "status",
  requestDate: "request_date",
  dueDate: "due_by",
  releasedDate: "initial_release_date",
  completionDate: "release_date",
  cycleTime: "cycle_time",
};

export function sortConfigToVendorRequestedApiSortParams(sortConfig) {
  return sortConfigToApiSortParamsWithFieldMap(
    VENDOR_REQUESTED_RFI_API_ORDER_BY_FIELD,
    sortConfig
  );
}

/**
 * Normalized row for Provider "Requested RFIs" grid (vendor-facing list).
 * Built on top of the shared My RFI mapper so date/GxP/location fields stay consistent.
 *
 * When the backend adds fields, extend `mapVendorRequestedRfiToGridRow` to read them
 * from `item` (e.g. item.auditor_name). Missing keys stay empty strings for display/export.
 */
export function mapVendorRequestedRfiToGridRow(item) {
  const base = mapMyRfiItemToGridRow(item);
  return {
    ...base,
    sponsor: item?.sponsorName ?? "",
  };
}

/** Column order for TableExportMenu (matches VendorRequestedRfiGridTable). */
export const VENDOR_REQUESTED_RFI_EXPORT_HEADERS = [
  "Sponsor",
  "Type",
  "GxP",
  "Template",
  "Location",
  "Risk Summary",
  "Status",
  "Request Date",
  "Due Date",
  "Release Date",
  "Completion Date",
  "Cycle Time",
];

/**
 * One export row per API item: same fields as purchaser "My RFIs" export but
 * the first column is Sponsor instead of Vendor.
 */
export function mapVendorRequestedItemToExportRecord(item) {
  const row = mapVendorRequestedRfiToGridRow(item);
  const { Vendor, ...rest } = mapMyRfiRowToExportRecord(row);
  return {
    Sponsor: row.sponsor || "",
    ...rest,
  };
}

